import {useEffect, useState} from 'react'
import BookIsbnResponse from './BookIsbnResponse'
import {BooksitoutServer} from '../../../config/BooksitoutServer'

const useBookIsbnRelated = (isbn: string | null) => {
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)

    const [relatedBooks, setRelatedBooks] = useState<BookIsbnResponse[]>([])

    useEffect(() => {
        if (isbn == null) {
            setIsError(true)
            setIsLoading(false)
        } else {
            BooksitoutServer.get(`/v1/book-isbn/${isbn}/related-books`)
                .then(res => setRelatedBooks(res.data))
                .catch(() => setIsError(true))
                .finally(() => setIsLoading(false))
        }
    }, [isbn])

    return [relatedBooks, isLoading, isError] as const
}

export default useBookIsbnRelated